import { Injectable } from '@angular/core';
import { AuthenticationService } from '../_services/authenticationService';
import { UtilityService, DataService, DialogService } from '../_services';
import { map } from 'rxjs/internal/operators/map';
import { CommonService } from '../_services/common.service';
import { Config } from '../_store/config';
import { StorageService } from '../_services/storage.service';
import { StringConstants } from '../_constants/stringConstants';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { InvoiceService } from './invoice.service';
import { AppConfigService } from '../_services/appConfigService';
import { DateUtilsService } from '../_services/dateUtils';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyDisplayService } from '../_services/currency-display.service';
import { CfMockService } from '../_services/cf-mock.service';


@Injectable({
  providedIn: 'root'
})
export class PayService {

  private cnNotExactOffsetCnSplit: string = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET_CNSPLIT');
  private cnNotExactOffset: string = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET');
  private cnSelectionSplitInvalidSelection: string = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CNSPLIT_INVALID_SELECTION');
  private deselectCnWithAmount: string = this.translate.instant('MESSAGES.DESELECT_CREDIT_NOTES_WITH_AMOUNT');
  private incorrectPayAmount: string = this.translate.instant('MESSAGES.INCORRECT_PAY_AMOUNT');
  private enterValidAmount: string = this.translate.instant('MESSAGES.ENTER_VALID_AMOUNT');
  private amountCannotExceed: string = this.translate.instant('MESSAGES.AMOUNT_CANNOT_EXCEED');
  private notMoreThanBillAmount: string = this.translate.instant('MESSAGES.NOT_MORE_THAN_BILL_AMOUNT');
  private withMaxAvailableDiscount: string = this.translate.instant('MESSAGES.WITH_MAX_AVAILABLE_DISCOUNT');
  private enterValidPayableAmount: string = this.translate.instant('MESSAGES.ENTER_VALID_PAYABLE_AMOUNT');
  private cannotSelectFutureDateOfPayment: string = this.translate.instant('MESSAGES.CANNOT_SELECT_FUTURE_DATE_OF_PAYMENT');
  private partialPayAllowedForOverdue: string = this.translate.instant('MESSAGES.PARTIAL_PAY_ALLOWED_FOR_OVERDUE');
  private uploadSuccessful: string = this.translate.instant('MESSAGES.UPLOAD_SUCCESSFUL');
  private deductionAmountInvalid: string = this.translate.instant('MESSAGES.DEDUCTION_AMOUNT_INVALID');


  currentUser;
  selectedInvoices = {};

  paymentSettings = {};

  scfFormData;

  private currentPayData: any = {
    reqData: {},
    resData: {}
  };

  //TODO
  //Get this from config
  private creditNoteDocTypeConfig = {
    '1': { dir: 'CreditNoteImg', ext: 'png' },
    '2': { dir: 'CreditNoteHtml', ext: 'html' },
    '3': { dir: 'CreditNotePdf', ext: 'pdf' }
  };

  constructor(
    private authenticationService: AuthenticationService,
    private dataService: DataService,
    private utilityService: UtilityService,
    private commonService: CommonService,
    private storageService: StorageService,
    private invoiceService: InvoiceService,
    private appConfigService: AppConfigService,
    private dialogService: DialogService,
    private dateUtils: DateUtilsService,
    private translate: TranslateService,    
    private currencyDisplayService: CurrencyDisplayService,
    private cfMockService: CfMockService
  ) {
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      if (!x) {
        this.paymentSettings = {};
      }
    });
    setTimeout(() => {
      this.setDynamicLables();
    }, 5000);
  }

  setDynamicLables() {
    this.cnNotExactOffsetCnSplit = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET_CNSPLIT');
    this.cnNotExactOffset = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET');
    this.cnSelectionSplitInvalidSelection = this.translate.instant('MESSAGES.CREDITNOTE_SELECTION_CNSPLIT_INVALID_SELECTION');
    this.deselectCnWithAmount = this.translate.instant('MESSAGES.DESELECT_CREDIT_NOTES_WITH_AMOUNT');
    this.incorrectPayAmount = this.translate.instant('MESSAGES.INCORRECT_PAY_AMOUNT');
    this.enterValidAmount = this.translate.instant('MESSAGES.ENTER_VALID_AMOUNT');
    this.amountCannotExceed = this.translate.instant('MESSAGES.AMOUNT_CANNOT_EXCEED');
    this.notMoreThanBillAmount = this.translate.instant('MESSAGES.NOT_MORE_THAN_BILL_AMOUNT');
    this.withMaxAvailableDiscount = this.translate.instant('MESSAGES.WITH_MAX_AVAILABLE_DISCOUNT');
    this.enterValidPayableAmount = this.translate.instant('MESSAGES.ENTER_VALID_PAYABLE_AMOUNT');
    this.cannotSelectFutureDateOfPayment = this.translate.instant('MESSAGES.CANNOT_SELECT_FUTURE_DATE_OF_PAYMENT');
    this.partialPayAllowedForOverdue = this.translate.instant('MESSAGES.PARTIAL_PAY_ALLOWED_FOR_OVERDUE');
    this.uploadSuccessful = this.translate.instant('MESSAGES.UPLOAD_SUCCESSFUL');
    this.deductionAmountInvalid = this.translate.instant('MESSAGES.DEDUCTION_AMOUNT_INVALID');
  }

  getNEFTBalance_CPG(invoice) {
    const req = {
      RC: invoice.RC,
      DC: invoice.DC,
      payex_cpg_code: invoice.CC,
      CRC: invoice.CRC,
      action: Config.webActions.NEFT_CRED_BAL
    }
    return this.utilityService.httpPost(req, this.appConfigService.urls.invoiceUrl).pipe(map(data => {
      return data.data;
    }));
  }

  // Logic for multi pay selection of invoices
  getSelectedInvoicesData() {
    return this.invoiceService.getSelectedInvoicesData();
  }

  setInvoicesForPay(invoices) {
    return this.storageService.add(StringConstants.INVOICE_multipayStr, invoices);
  }

  getInvoicesSetForPay() {
    return this.storageService.get(StringConstants.INVOICE_multipayStr).then(invoices => {
      return invoices;
    });
  }

  clearSelectedInvoicesToPay(invoices = []) {
    this.storageService.remove([StringConstants.INVOICE_multipayStr]);
  }

  private getCashDiscount(payData) {
    const req = {
      docIds: payData.invoiceData.docIds,
      buyerCode: payData.invoiceData.invoice.buyerCode,
      sellerCode: payData.invoiceData.invoice.sellerCode,
      payDate: payData.payModel.payDate,
      payableAmt: this.dataService.roundNumToTwoDecimalPlace(payData.invoiceData.PP ? payData.invoiceData.AA : payData.invoiceData.BA)
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('CASH_DISCOUNT')).pipe(map(data => {
      return {
        CDD: '',
        SCDD: '',
        CDDMsg: '',
        CDF: '',
        CDV: '',
        CDAmount: '',
        SCDF: '',
        totalCashDiscount: 0
      }
    }));
  }
  private getEligibleCashDiscount(payData) {
    const deductions: any[] = (payData.invoiceData.invoices || []).map(inv => {
      return {
        docId: inv.docId,
        deductions: (inv.deductions || []).concat((inv.whtDeductions || [])),
        amt: ((inv.totalDeductionAmt || 0) + (inv.withholdTaxAmount)),
        dueAmt: inv.dueAmt
      }
    });
    const req = {
      docId: payData.invoiceData.docIds,
      buyerCode: payData.invoiceData.invoice.buyerCode,
      sellerCode: payData.invoiceData.invoice.sellerCode,
      deduction: deductions,
      payDate: moment(payData.payModel.payDate).format('YYYY-MM-DD'),
      cnId: (payData.selectedCreditNotesList || []).map(item => item.docId),
      payableAmt: this.dataService.roundNumToTwoDecimalPlace(payData.invoiceData.PP ? payData.invoiceData.AA : payData.invoiceData.BA)
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('GET_ELLIGIBLE_CASH_DISCOUNT')).pipe(map(data => {
      return {
        CDD: '',
        SCDD: '',
        CDDMsg: '',
        CDF: '',
        CDV: '',
        CDAmount: '',
        SCDF: '',
        cdInvoices: (data.data.invoice || []),
        totalCashDiscount: +data.data.totalCashDiscount
      }
    }));
  }
  getPaymentSettings(invoiceData) {
    const req = {
      docIds: invoiceData.docIds,
      buyerCode: invoiceData.invoice.buyerCode,
      sellerCode: invoiceData.invoice.sellerCode
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAYSETTINGS')).pipe(map(data => {
      return data.data;
    }));
  }

  getCreditNotesForInvoice(payData, isKnockOff=false) {
    const docDetails = [];
    const selectedInvoices = !isKnockOff ? payData.selectedInvoices : payData.invoices;
    selectedInvoices.forEach((invoice) => {
      docDetails.push({
        docId: invoice.docId,
        docType: invoice.docType,
      });
    });
    const deductionData = this.getDeductionsWithShortPay(payData, isKnockOff);
    const isPartialPay = deductionData.totalPayable !== payData.invoiceData.BA;
    const req = {
      docIds: payData.invoiceData.docIds,
      buyerCode: payData.invoiceData.invoice.buyerCode,
      sellerCode: payData.invoiceData.invoice.sellerCode,
      partialPay: isPartialPay,
      lobs: payData.invoiceData.divCodes,
      deductions: deductionData.deductions,
      docDetails: docDetails,
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('CREDIT_NOTES_PAYMENT')).pipe(map(data => {
      const creditNotes = ((data.data || {}).creditNotes) || [];
      creditNotes.forEach(cn => {
        cn.amount = Math.abs(parseFloat(cn.docAmt[0].amt));
        cn.amountFormatted = this.dataService.displayNumberAsCurrency(cn.amount);
        const docDateMoment = this.dateUtils.convertDateUnknownFormat(cn.docDate);
        cn.dtForSort = docDateMoment.toDate().getTime();
        cn.cnDate = docDateMoment.format(Config.dateFormat);
        cn.currCode = cn.docAmt[0].currCode || Config.defaultCurr;
      });
      return creditNotes.filter(cn => {
        return cn.currCode === payData.invoiceData.currCode;
      });
    }));

  }

  getPaymentReasons(payData) {
    const req = {
      docIds: payData.invoiceData.docIds,
      buyerCode: payData.invoiceData.invoice.buyerCode,
      sellerCode: payData.invoiceData.invoice.sellerCode,
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAY_REASONS')).pipe(map(data => {
      return data.data;
    }));
  }

  // getPaymentOptions(payData) {
  //   const req = {
  //     docIds: payData.invoiceData.docIds,
  //     buyerCode: payData.invoiceData.invoice.buyerCode,
  //     sellerCode: payData.invoiceData.invoice.sellerCode,
  //   };
  //   return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAYMENT_OPTIONS')).pipe(map(data => {
  //     return data.data;
  //   }));
  // }

  getPaymentOptions(payData) {
    const req = {
      docIds: payData.invoiceData.docIds,
      buyerCode: payData.invoiceData.invoice.buyerCode,
      sellerCode: payData.invoiceData.invoice.sellerCode,
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAYMENT_OPTIONS')).pipe(map(data => {
      console.log("this is data");
      console.log(data.data.payOptions);
      const docType = payData.invoiceData.docType || payData.invoiceData.label;
      console.log("docType : ", docType);
      
      data.data.payOptions.forEach(element => {
        if(data.data.payOptions.length == 1){
          if(element.pm == "XiCard"){
            element.title = `Card - XXXX - XXXX - XXXX - ${element.cardLastFourDigit}`;
            element.showCVV = true;
          }
        if(element.pm == "XiCheck"){
            element.title = `eCheck  - XXXX - XXXX - XXXX -  ${element.accountLastFourDigit || '0000'}`;
            element.accountType = element.paymentOption;
            element.cardNumber = element.accountNumber
        }
        }

        element.changePayDate = true
        console.log('element');
        
        console.log(element);
        
      });

      // Enable Channel Finance only for original invoices / debit notes (not for LRP or other doc types)
      if (docType === 'INV' || docType === 'DN') {
        const currentCFData = this.cfMockService.getCurrentCFData();
        const availableCredit = currentCFData.currentCFBalance - currentCFData.utilizedCF;

        // Read lenders enabled by the seller app via Local Storage
        let cfLenders: string[] | null = null;
        try {
          const cfBuyerLendersRaw = localStorage.getItem('cf_buyer_lenders');
          if (cfBuyerLendersRaw) {
            const cfBuyerLenders = JSON.parse(cfBuyerLendersRaw);
            const firstBuyerCode = Object.keys(cfBuyerLenders)[0];
            if (firstBuyerCode && Array.isArray(cfBuyerLenders[firstBuyerCode]) && cfBuyerLenders[firstBuyerCode].length) {
              cfLenders = cfBuyerLenders[firstBuyerCode].map((l: any) => l.lenderName);
            }
          }
        } catch (e) {
          console.warn('Failed to read cf_buyer_lenders from localStorage', e);
        }

        if (cfLenders) {
          // Add one CF option per lender (in reverse so first lender ends up first after unshift)
          [...cfLenders].reverse().forEach(lenderName => {
            data.data.payOptions.unshift({
              "accountNumber": "192838383893",
              "lenderName": lenderName,
              "totalCredit": currentCFData.currentCFBalance,
              "amountUtilization": currentCFData.utilizedCF,
              "availableCredit": availableCredit,
              "rateOfInterest": "0",
              "pm": "CF",
              "key": "CF",
              "processingFees": 5,
              "latePaymentCharges": 15,
              "title": `Interest Free Payment from ${lenderName}`,
              "sellerName": lenderName
            });
          });
        } else {
          // No need for a fallback as per request.
          // Fallback: no seller-configured lenders found, use default
          // data.data.payOptions.unshift({
          //   "accountNumber": "192838383893",
          //   "lenderName": "Interest Free Payment from Lender",
          //   "totalCredit": currentCFData.currentCFBalance,
          //   "amountUtilization": currentCFData.utilizedCF,
          //   "availableCredit": availableCredit,
          //   "rateOfInterest": "0",
          //   "pm": "CF",
          //   "key": "CF",
          //   "processingFees": 5,
          //   "latePaymentCharges": 15,
          //   "title": "Interest Free Payment from Lender",
          //   "sellerName": "Lender"
          // });
        }
      }
      console.log(data.data);
      
      if(data.data.payOptions.length && data.data.payOptions){
        payData.availablePaymentOptions = true;
      }else{
        payData.availablePaymentOptions = false;        
      }

      if(data?.data?.payOptions?.length == 1 && data.data.payOptions){
        payData.availablePaymentOptions = false;
      }

      return data.data;
    }));
  }

  initPay(invoices, options: any = {}) {
    const selectedInvoices = invoices.map(inv => {
      return Object.assign({}, inv, {
        deductions: [],
        whtDeductions: [],
        deductionModel: {
          reason: '',
          amt: '',
          isValid: false,
        },
        whtDeductionModel: {
          reason: '',
          amt: '',
          isValid: false,
        }
      });
    });
    const isFromMultipayGroup = selectedInvoices[0].selectedForPay;
    const isMultiPay = (selectedInvoices && selectedInvoices.length > 1) || isFromMultipayGroup;
    const invoice = selectedInvoices && selectedInvoices.length && selectedInvoices[0];
    const setCashDiscount = (payData) => {

      //if doing a CN pay, dont clear credit notes
      let isCNPay = false;
      if (!payData.bankAmt && payData.selectedCRAmount > 0) {
        isCNPay = true;
      }
      // if (!payData.invoiceData.getCashDiscount || payData.payConfig.hideCashDiscount) {
      //   if (!isCNPay && !payData.invoiceData.doCDCallAfterCNSelection) {
      //     payData.clearCreditNotesSelection();
      //   }
      //   payData.getPayableAmount();
      //   return;
      // }

      return this.getEligibleCashDiscount(payData).subscribe(data => {
        payData.cashDiscountData = Object.assign({}, payData.cashDiscountData, data);
        if (!payData.cashDiscountData.maxDiscount || (payData.cashDiscountData.maxDiscount < payData.cashDiscountData.totalCashDiscount)) {
          payData.cashDiscountData.maxDiscount = payData.cashDiscountData.totalCashDiscount;
        };
        // if (!isCNPay && !payData.invoiceData.doCDCallAfterCNSelection) {
        //   payData.clearCreditNotesSelection();
        // }
        payData.getPayableAmount();
        payData.checkCreditNotesToBeDisabled();
        this.processDeductions(payData, true);
        return data;
      }, () => {
        payData.invCDAmts = {};
        payData.retrievingCashDiscount = false;
        this.processDeductions(payData, true);
      });
    };
    const amt = this.dataService.roundNumToTwoDecimalPlace(selectedInvoices.reduce((total, inv) => {
      return total + inv.dueAmt;
    }, 0));
    const docAmt = this.dataService.roundNumToTwoDecimalPlace(selectedInvoices.reduce((total, inv) => {
      return total + inv.docAmt;
    }, 0));
    const invoiceData: any = {
      isMultiPay: isMultiPay,
      invoices: selectedInvoices,
      invoice: selectedInvoices[0],
      getCashDiscount: false,
      BA: amt,
      dueAmt: amt,
      //Initial Approved amount is same as BA
      AA: amt,
      docIds: selectedInvoices.map(inv => inv.docId),
      divCodes: selectedInvoices.map(inv => inv.divCode),
      isDiscount: false,
      payUsingCN: false,
      label: isMultiPay ? selectedInvoices.reduce((label, inv) => {
        if (inv.docType !== label) {
          label = 'Document';
        }
        return label;
      }, selectedInvoices[0].docType) : invoice.docType,
      currCode: selectedInvoices[0].currCode || Config.defaultCurr,
      formattedBalAmt: this.currencyDisplayService.getFormattedCurrencyStr({amt, curr: selectedInvoices[0].currCode}),
      formattedTotalAmt: this.currencyDisplayService.getFormattedCurrencyStr({amt: docAmt, curr: selectedInvoices[0].currCode}),
      PP: false,
      totalDeductions: selectedInvoices.reduce((total, inv) => {
        return total + (inv.totalDeductions || 0);
      }, 0),
      totalDNs: selectedInvoices.filter(inv => inv.docType === 'DN').length,
    };

    let payData: any = {
      selectedInvoices: selectedInvoices,
      cashDiscountData: { CDF: 0 },
      banks: [],
      invoice: invoice,
      paySettings: {},
      partialPayReasons: [],
      whtReasons: [],
      availablePaymentOptions : false,
      availableCreditNotes : false,
      getPayableAmount: () => {

        let amt = payData.invoiceData.AA;
        if (payData.cashDiscountData && (payData.cashDiscountData.totalCashDiscount)) {
          amt -= (payData.cashDiscountData.totalCashDiscount);
        }
        if (payData.invoiceData.partialPayTotalCD && payData.invoiceData.accumulateCD) {
          amt -= payData.invoiceData.partialPayTotalCD;
        }
        if (payData.invoiceData.roundOffObj && payData.invoiceData.roundOffObj.isRoundOff) {
          amt = payData.invoiceData.roundOffObj.amt;
        }
        if (payData.isFromMultipayGroup) {
          amt -= payData.invoiceData.totalDeductions;
        }
        amt = this.dataService.roundNumToTwoDecimalPlace(amt);
        //payData.invoiceData.cashDiscountFlag - hold cash discount, dont update values to display subtracted cash discount
        //for CPG's like V-Guard etc. we accumulate CD for CPGs like RRKABEL where we get cashDiscountFlag = 1
        // if (payData.invoiceData.PP && (!payData.invoiceData.cashDiscountFlag || payData.invoiceData.cashDiscountFlag === 2)) {
        //   payData.payModel.amtToPay = payData.invoiceData.AA;
        //   payData.bankAmt = payData.invoiceData.AA;
        // } else {
        payData.payModel.amtToPay = amt;
        payData.bankAmt = amt;
        // }
        payData.payingAmt = amt;
        payData.cnSplit = false;
        if (payData.creditNotes && payData.creditNotes.length) {
          let selectedCRAmount = 0;
          let creditNotesSelected = [];
          payData.creditNotes.forEach(crItem => {
            if (crItem.selected) {
              selectedCRAmount += crItem.amount;
              creditNotesSelected.push(crItem);
            }
          });
          if (payData.bankAmt < selectedCRAmount) {
            payData.cnSplit = true;
          }
          payData.creditNotesSelected = selectedCRAmount > 0;
          payData.selectedCreditNotesList = creditNotesSelected || [];
          payData.creditNotesSelectedStr = creditNotesSelected.map(item => item.CN_ID).join(",");
          payData.selectedCreditNotesAmount = selectedCRAmount.toFixed(2);
          payData.selectedCRAmount = selectedCRAmount;
          payData.bankAmt -= selectedCRAmount;
          if (payData.bankAmt < 0) {
            payData.bankAmt = 0;
          }
        }
        // TODO
        // Check for Cash discount and deduct cd amount from bankAmt
        payData.bankAmt = this.dataService.roundNumToTwoDecimalPlace(payData.bankAmt);
        payData.payModel.amtToPayDisplay = this.currencyDisplayService.getFormattedCurrencyStr({amt: payData.payModel.amtToPay, curr: payData.invoiceData.currCode})
        payData.selectedCreditNotesAmountFormatted = this.currencyDisplayService.getFormattedCurrencyStr({amt: payData.selectedCreditNotesAmount, curr: payData.invoiceData.currCode});
        payData.validatePayAmount();
        if(payData.creditNotes.length && payData.creditNotes){
          payData.availableCreditNotes = true;
        }else{          
          payData.availableCreditNotes = false;
        }    
        
        if(payData.creditNotesSelected){          
          payData.availableCreditNotes = false;
        }

        if(!payData.creditNotesSelected && payData.bankAmt > 0){
          payData.availableCreditNotes = false;
        }
        if(payData?.paymentOptions?.length == 1){
          payData.availablePaymentOptions = false;
        }
        if(payData?.paymentOptions?.length == 1 && payData.paymentOptions[0].pm.toUpperCase() === "XICARD"){
          payData.availablePaymentOptions = false;
        }
        if(!payData.creditNotesSelected && payData?.paymentOptions?.length == 1 && payData.paymentOptions[0].pm.toUpperCase() === "XICARD"){
          payData.availableCreditNotes = false;
          payData.availablePaymentOptions = false;
        }
        
        if(payData.bankAmt == 0){
          payData.availableCreditNotes = false;
          payData.availablePaymentOptions = false;          
        }
      },
      getPaymentReasons: () => {
        this.getPaymentReasons(payData).subscribe(data => {
          payData.payReasons = data;
          if (payData.payReasons && payData.payReasons.partialPayReasons && !payData.payReasons.partialPayReasons.length) {
            payData.payReasons.partialPayReasons.push('Any other reason');
          }
          if (payData.payReasons && payData.payReasons.rejectReasons) {
            payData.payReasons.rejectReasons.forEach(rejectReason => {
              const isReasonPaidByCheque = (rejectReason.reason || '').toLowerCase().indexOf('by cheque') !== -1;
              if (isReasonPaidByCheque && typeof rejectReason.getChequeDetails === 'undefined') {
                //TODO - Remove hardcoded condition for SBD & Lactalis
                const isSBD_Lactalis = ((payData.invoice || {}).sellerCode === 'SBD') || ((payData.invoice || {}).sellerCode === 'Lactalis');
                rejectReason.getChequeDetails = isSBD_Lactalis;
                console.log(payData);
              }
            })
          }
          payData.partialPayReasons = data.partialPayReasons;
          payData.whtReasons = data.deductions;
          payData.paymentReasonsReceived = true;
          payData.addMandatoryWHTReasons(payData);
        });
      },
      getPaymentOptions: () => {
        this.getPaymentOptions(payData).subscribe(data => {
          payData.paymentOptions = (data && data.payOptions) || [];
          const paymentOptionsMap = {};
          if (payData.paymentOptions && payData.paymentOptions.length) {
            payData.paymentOptions.forEach(payOption => {
              // Change titles only if currency code is not INR
              if (payData.invoice && payData.invoice.currCode !== 'INR') {
                if (payOption.pm === 'ACH') {
                  payOption.title = payOption.title.replace('ACH', 'ACH');
                }
                if (payOption.pm === 'NEFT') {
                  payOption.title = payOption.title.replace('NEFT/RTGS', 'Wire Transfer');
                }
              }
              if (!paymentOptionsMap[payOption.pm]) {
                paymentOptionsMap[payOption.pm] = [];
              }
              paymentOptionsMap[payOption.pm].push(payOption);
            });
            payData.payModel.bank = payData.paymentOptions[0];
            payData.paymentOptionsMap = paymentOptionsMap;
          }
          if (options && options.onBankOptionsRetrieved) {
            options.onBankOptionsRetrieved();
          }
        });
      },
      getPayConfig: () => {
        payData.config.allowToChangePaymentAmount = true;
        payData.config.allowToChangePaymentDate = invoice.overDueDays < 0;
        payData.config.allowToSelectedCreditNotes = true;//invoice.overDueDays < 0;
        payData.config.paymentAmountChangeDisabled = true;
      },
      getCreditNotesForInvoice: () => {
        this.getCreditNotesForInvoice(payData).subscribe(creditNotes => {
          console.log("get credit not for invoice");
          console.log(creditNotes);
          
          payData.creditNotes = creditNotes;
          payData.checkCreditNotesToBeDisabled();
        });
      },
      clearCreditNotesSelection: () => {
        if (payData.creditNotes && payData.creditNotes.length) {
          payData.creditNotes.forEach(cr => {
            cr.selected = false
          });
        }
        payData.creditNotesSelected = false;
        payData.creditNotesSelectedStr = [];
        payData.selectedCreditNotesAmount = "";
        payData.selectedCRAmount = "0";
        payData.selectedCreditNotesList = [];
      },
      checkCreditNotesToBeDisabled: () => {
        //const cnSplitAllowed = payData.paySettings && (payData.paySettings.cnSplitAllowed || payData.paySettings.cnSplit);
        //const cnSplitOnPartPay = payData.paySettings && payData.paySettings.cnSplitOnPartPay;
        const cnSplitSetting = payData.paySettings && payData.paySettings.cnSplit;
        const cnSplitOnPartPaySetting = payData.paySettings && payData.paySettings.cnSplitOnPartPay;
        //const payUsingCN = payData.paySettings && payData.paySettings.cnPayAllowed;
        //const payUsingCNPartPay = payData.paySettings && payData.paySettings.cnPayPartPayAllowed;
        payData.creditNotes.forEach(creditNote => {
          if (creditNote.selected) {
            creditNote.disabled = false;
          } else if (payData.bankAmt <= 0) {
            creditNote.disabled = true;
          } else {
            const cnAmount = this.dataService.roundNumToTwoDecimalPlace(creditNote.amount);
            const bankAmount = this.dataService.roundNumToTwoDecimalPlace(payData.bankAmt);
            // cn selection logic
            //  1.  Don't disable it, if its already selected
            //  2.  If cnSplitAllowed (CN > Invoice, we allow selection of cn even if bank amount is less than CN amount, once bank amt becomes zero, selection is disabled),
            // cnSplitAllowed = 1 Only for full-payment
            //  2 = Part payment
            //  3 = For both
            //  3.  If payUsingCN, offsetting of cn having exact amount as bank amount is allowed
            //  4.  For Bridgestone we have CN > Invoice, but if doing partial pay it should not allow CN > Invoice, but CN = Invoice is allowed
            // if (payData.invoiceData.PP) {
            //   creditNote.disabled = cnSplitOnPartPay ? false : (payUsingCNPartPay ? cnMoreThanBankAmt : cnAmtMoreThanOrEqualBankAmt);
            // } else {
            //   creditNote.disabled = cnSplitAllowed ? false : (payUsingCN ? cnMoreThanBankAmt : cnAmtMoreThanOrEqualBankAmt);
            // }
            let disableCreditNote = false;
            const cnSetting = payData.invoiceData.PP ? cnSplitOnPartPaySetting : cnSplitSetting;
            // L meaning ("L", "Less than Invoice"),
            // G meaning ("G", "Greater than Invoice"),
            // E meaning ("E", "Equal to Invoice"),
            // GE meaning ("GE", "Greater than or Equal to Invoice"),
            // LE meaning ("LE", "Less than or Equal to Invoice"), - Default Value
            // NE meaning ("NE", "Not Equal to Invoice"),
            // A meaning ("A", "No restriction");
            switch (cnSetting) {
              case 'L':
                disableCreditNote = cnAmount >= bankAmount;
                break;
              case 'G':
                disableCreditNote = cnAmount <= bankAmount;
                break;
              case 'E':
                disableCreditNote = cnAmount !== bankAmount;
                break;
              case 'GE':
                disableCreditNote = cnAmount < bankAmount;
                break;
              case 'LE':
                disableCreditNote = cnAmount > bankAmount;
                break;
              case 'NE':
                disableCreditNote = cnAmount === bankAmount;
                break;
              case 'A':
                disableCreditNote = false;
                break;
              default:
                disableCreditNote = cnAmount > bankAmount;
                break;
            }
            creditNote.disabled = disableCreditNote;
          }
        });
      },
      validateSelectedCRN: () => {
        const payUsingCN = payData.paySettings && payData.paySettings.payByCN;
        const cnSplitAllowed = payData.paySettings && (payData.paySettings.cnSplitAllowed || payData.paySettings.cnSplit);
        const banksCount = (payData.paymentOptions || []).length;
        const payAmt = payData.payingAmt; // payData.invoiceData.PP ? payData.invoiceData.AA : payData.invoiceData.BA;
        if (payUsingCN && !banksCount && payData.bankAmt) {
          if (cnSplitAllowed) {
            return (this.cnNotExactOffsetCnSplit);
          } else {
            return (this.cnNotExactOffset);
          }
        }
        // check for selection for cnSplitSelection
        // 6500   -   Payable Amount
        // 100 50 4000 2500 - Credit notes
        // technically user can select all the credit notes, but we all credit notes are selected then we should restrict user to restrict 4000 2500
        if (cnSplitAllowed) {
          const totalCreditNotesSelected = (payData.selectedCreditNotesList || []).length;
          let selectedAmt = 0;
          let isInvalidSelection = false;
          const invalidCreditNotes = [];
          payData.selectedCreditNotesList.sort((a, b) => {
            if (a.amount < b.amount)
              return 1;
            if (a.amount > b.amount)
              return -1;
            return 0;
          });

          payData.selectedCreditNotesList.forEach((item, nIndex) => {
            selectedAmt += item.amount;
            if (selectedAmt >= payAmt) {
              if (isInvalidSelection) {
                invalidCreditNotes.push(item);
              }
              if (nIndex < totalCreditNotesSelected - 1) {
                //invalid credit notes selection
                isInvalidSelection = true;
              }
            }
          });
          if (isInvalidSelection) {
            return `${this.cnSelectionSplitInvalidSelection} ${this.deselectCnWithAmount} ${invalidCreditNotes.map(item => this.dataService.roundNumToTwoDecimalPlace(item.amount)).join(', ')}.`;
          }
        }
        return;
      },
      getCashDiscount: (payData) => {
        setCashDiscount(payData);
      },
      warnings: [],
      payableAmount: 0,
      bankAmt: 0,
      editableAmt: invoiceData.BA,
      creditNotes: [],
      selectedCreditNotesAmount: 0,
      selectedCreditNotesList: [],
      creditNotesSelected: false,
      validateAmt: (amtToPay) => {
        let error;
        if (!amtToPay || amtToPay <= 0) {
          error = `${this.incorrectPayAmount}, ${this.enterValidAmount}`;
        }
        if (amtToPay > payData.bankAmt) {
          error = `${this.incorrectPayAmount}, ${this.amountCannotExceed} ${this.dataService.displayNumberAsCurrencyFlag(payData.bankAmt, payData.invoiceData.CC)}`;
        }
        return error;
      },
      validatePayAmount: (amtToPay) => {
        if (typeof amtToPay === 'undefined') {
          amtToPay = payData.payModel.amtToPay;
        }
        payData.payAmtError = payData.validateAmt(amtToPay);
      },
      validatePartialPayAmount: (amtToPay) => {
        if (typeof amtToPay === 'undefined') {
          amtToPay = payData.payModel.editableAmt;
        }
        const invBalAmt = invoiceData.BA;
        if (amtToPay === invBalAmt) {
          return;
        }
        const err = this.notMoreThanBillAmount
        if (amtToPay > invoiceData.BA) {
          return err
        }
        if (amtToPay > (invoiceData.BA - payData.cashDiscountData.maxDiscount) && payData.payConfig.partialPayCDEnabled) {
          return err + ` ${this.withMaxAvailableDiscount}.`;
        }
        if (amtToPay <= 0) {
          return 'Please enter valid Payable Amount';
        }
        return;
      },
      initPartialPay: () => {
        if (!payData.invoiceData.dontResetPartialPay) {
          payData.payModel.editableAmt = invoiceData.BA;
          //payData.partialReason = undefined;
          payData.payModel.partialOtherReason = undefined;
        }
      },
      setPartialAmt: (amtToSet) => {
        payData.clearCreditNotesSelection();
        payData.invoiceData.roundOffObj = {};
        let isRoundOff = false;
        if (invoiceData.roundOff && payData.cashDiscountData.maxDiscount) {
          const orgPayableAmt = (invoiceData.BA - payData.cashDiscountData.maxDiscount);
          const roundOffAmtMax = (orgPayableAmt + invoiceData.roundOff);
          const roundOffAmtMin = (orgPayableAmt - invoiceData.roundOff);
          if (amtToSet <= roundOffAmtMax && amtToSet >= roundOffAmtMin) {
            payData.invoiceData.AA = invoiceData.BA;
            isRoundOff = true;
            payData.invoiceData.roundOffObj = {
              isRoundOff: true,
              amt: amtToSet,
              roundOffAmt: (orgPayableAmt - amtToSet)
            };
          } else if (amtToSet > roundOffAmtMax) {
            amtToSet = invoiceData.BA;
          }
        }
        if ((amtToSet < (invoiceData.BA)) && !isRoundOff) {
          payData.invoiceData.PP = true;
          payData.invoiceData.AA = amtToSet;
        } else {
          payData.invoiceData.PP = false;
          payData.invoiceData.AA = payData.invoiceData.BA;
        }
        if (payData.invoiceData.PP && payData.invoiceData.isSCFormRequired) {
          payData.invoiceData.dontResetPartialPay = payData.invoiceData.dontResetPartialPayForm && true;
        }
        payData.getPayableAmount();
        payData.initPartialPay();
        setCashDiscount(payData);
        payData.getCreditNotesForInvoice();
      },
      resetPayDate: () => {
        payData.payModel.payDate = this.dataService.getToday();
      },
      setPaymentMode: (doDiscountCall = true) => {
        const payModeIsExt = payData.payModel.bank.isExtPay;
        const payModel = payData.payModel;
        const checkBalanceBeforePay = payModel.bank.checkBalanceBeforePay;
        const isPaymentProcessingApplicable = (payModel.bank.pm === 'CF') && (payModel.bank?.processingFees);
        payData.paymentMode = payModeIsExt ? payData.payModel.bank.umrn_number : 'ACH';
        if (payModeIsExt) {
          payData.resetPayDate();
          //payData.payModel.payDate = this.dataService.getToday()
        }
        if (doDiscountCall) {
          setCashDiscount(payData);
        }

        if (checkBalanceBeforePay && !payModel.bank.balance) {
          payModel.bank.retrievingBalance = true;
          this.getBalance(payData, payData.invoiceData.invoice).subscribe(data => {
            payModel.bank.retrievingBalance = false;
            payModel.bank.paymentNotAllowed = false;
            if (!data.paymentAllowed) {
              payModel.bank.paymentNotAllowed = true;
              this.dialogService.showInfoAlert(data.validationMsg);
            }
          }, () => {
            payModel.bank.paymentNotAllowed = false;
            payModel.bank.retrievingBalance = false;
          });
        }

        if (isPaymentProcessingApplicable) {
            payData.processingFeesData = {
              percentage: payModel.bank.processingFees,
              amt: 0
            }
        } else {
          payData.processingFeesData = {};
        }
      },
      autoSelectCreditNotes: (mode) => {
        const selectCreditNotesByOlderstFirst = () => {
          creditNotes.forEach(crn => {
            if (!crn.disabled) {
              crn.selected = true;
              payData.getPayableAmount();
              payData.checkCreditNotesToBeDisabled();
            }
          });
        };
        const selectCreditNotesByAmountFirst = () => {
          creditNotes.forEach(crn => {
            if (!crn.disabled) {
              crn.selected = true;
              payData.getPayableAmount();
              payData.checkCreditNotesToBeDisabled();
            }
          });
        };


        const creditNotes = payData.creditNotes;
        switch (mode) {
          case 'Oldest first':
            creditNotes.sort((a, b) => a.dtForSort - b.dtForSort);
            selectCreditNotesByOlderstFirst();
            // sort by date
            break;
          case 'Lowest Amt first':
            creditNotes.sort((a, b) => a.amount - b.amount);
            selectCreditNotesByAmountFirst();
            // sort by amt
            break;
          case 'Optimal Selection':

            break;
          default:
            break;
        }
      },
      addMandatoryWHTReasons: (payData) => {
        if (payData.paymentSettingsReceived && payData.paymentReasonsReceived) {
          // Process mandatory partial pay reasons
          if (payData.isPartialPayEnabled) {
          }
          // Process mandatory wht deductions
          if (payData.isWHTEnabled && payData.whtReasons && payData.whtReasons.length) {
            const mandatoryWHTReasons = payData.whtReasons.filter(wht => wht.mandatory);
            if (mandatoryWHTReasons.length) {
              payData.invoiceData.invoices.forEach(inv => {
                const whtReason = mandatoryWHTReasons[0];
                if (inv.enableWHT) {
                  inv.whtDeductionModel = {
                    reason: Object.assign({}, whtReason),
                    amt: '',
                    isValid: false,
                  };
                  this.calculateDeductionAmt(payData, inv, inv.whtDeductionModel);
                  inv.whtDeductionModel.isValid = this.validateDeduction(payData, inv, inv.whtDeductionModel);
                  if (inv.whtDeductionModel.isValid) {
                    inv.whtDeductionModel.mandatory = true;
                    this.addDeductionToInvoice(payData, inv, inv.whtDeductionModel, inv.whtDeductions, true);
                  }
                }
              })
            }
          }
        }
      },
      partialReason: '',
      invoiceData: invoiceData,
      isFromMultipayGroup: isFromMultipayGroup,
      isPartialPayEnabled: false
    };

    const minOverDueDate = invoiceData.invoices.reduce((minDate, inv) => {
      if (moment(inv.dueDate) < moment(minDate)) {
        minDate = inv.dueDate;
      }
      return minDate;
    }, invoiceData.invoices[0].dueDate)
    const maxOverdueDaysCnt = invoiceData.invoices.reduce((maxOverdueDays, inv) => {
      if (inv.overDueDays > maxOverdueDays) {
        maxOverdueDays = inv.overDueDays;
      }
      return maxOverdueDays;
    }, invoiceData.invoices[0].overDueDays)
    let payModel: any = {
      payDate: this.dateUtils.getToday(),
      minDate: this.dateUtils.getFormattedDate(this.dateUtils.getToday()),
      maxDate: this.dateUtils.getFormattedDate(maxOverdueDaysCnt < 0 ? this.dateUtils.getFormattedDate(minOverDueDate) : this.dataService.getToday()),
      amtToPay: invoiceData.BA,
      editableAmt: invoiceData.BA,
    };
    payData.payModel = payModel;
    payData.getPayableAmount();
    if (maxOverdueDaysCnt > 0) {
      //TODO
      //Check for multipay
      invoiceData.overDueWarning = `${this.cannotSelectFutureDateOfPayment}`
      const overdurWarning = [
        invoiceData.overDueWarning,
        payData.invoice.isInv ? `, ${this.partialPayAllowedForOverdue} ${invoice.docType}.` : `.`
      ].join('');
      payData.warnings.push(overdurWarning);
    }
    payData.getCreditNotesForInvoice();
    payData.getPaymentReasons();
    payData.getPaymentOptions();
    invoiceData.partialPaidHelperText = '';
    const sellerMessages = invoiceData.invoices.reduce((messages, invoice) => {
      if (!messages[invoice.sellerMsg]) {
        messages[invoice.sellerMsg] = 1;
      }
      return messages;
    }, {});
    payData.sellersMessages = Object.keys(sellerMessages).map(key => key);
    this.updateMultipaySettings(payData, options);
    this.processDeductions(payData);
    return payData;
  }

  setSCFData(payData, scfConfig) {
    this.scfFormData = {};
    scfConfig.forEach(scfConfig => {
      this.scfFormData[scfConfig.key] = parseFloat(payData[scfConfig.key]);
      if (scfConfig.vidSelection) {
        this.scfFormData[scfConfig.vidKey] = scfConfig.vidsSelected.map(vid => vid.vid).join(',');
        this.scfFormData[scfConfig.idKey] = scfConfig.vidsSelected.map(vid => vid.id).join(',');
      }
    });
    this.scfFormData.DA = parseFloat(payData.DA);
  }

  getSCFData() {
    return this.scfFormData;
  }

  updateMultipaySettings(payData, options) {
    this.getPaymentSettings(payData.invoiceData).subscribe(data => {
      payData.paySettings = data;
      payData.invoiceData.rejectAllowed = data.rejectAllow;
      payData.invoiceData.partialPay = data.partialPay;
      payData.invoiceData.payByCN = data.payByCN;
      if (options && options.onMultipaySettingsReceived) {
        options.onMultipaySettingsReceived();
      }
      // Deduction flags
      payData.invoiceData.invoices.forEach(inv => {
        if (inv.docType === 'DN') {
          inv.enablePartialPay = data.partialPayDN || false;
          inv.enableWHT = data.deductionAllowDN || false;
        } else {
          inv.enablePartialPay = data.partialPay || false;
          inv.enableWHT = data.deductionAllow || false;
        }
        inv.enableDeduction = inv.enablePartialPay || inv.enableWHT
      });
      payData.isPartialPayEnabled = payData.invoiceData.invoices.filter(inv => inv.enablePartialPay).length > 0;
      payData.isWHTEnabled = payData.invoiceData.invoices.filter(inv => inv.enableWHT).length > 0;
      payData.showAmtEdit = payData.isPartialPayEnabled || payData.isWHTEnabled;
      payData.paymentSettingsReceived = true;
      payData.addMandatoryWHTReasons(payData);
    }, () => {
      // error occured when doing a multi-pay settings call
      if (options && options.onMultipaySettingsError) {
        options.onMultipaySettingsError();
      }
    });
  }

  //TODO: check this out...
  payInvoice(payData, invoice) {
    let multipayDeductionData = [];
    if (payData.isMultiPartialPay) {
      multipayDeductionData = payData.invoiceData.invoices.map(inv => {
        return {
          docId: inv.docId,
          deductions: (inv.deductions || []).concat((inv.whtDeductions || [])),
          amt: ((inv.totalDeductionAmt || 0) + (inv.withholdTaxAmount)),
          dueAmt: inv.dueAmt
        }
      }).filter(item => item.amt > 0);
    }
    const cashDiscounts = (payData.cashDiscountData.cdInvoices || []).map(val => ({ docId: val.docId, discountAmt: +val.discountAmt }));
    const isCNPay = !payData.bankAmt && payData.selectedCreditNotesList.length > 0;
    const payOption = isCNPay ? undefined : Object.assign({}, payData.payModel.bank);
    if (payOption?.pm === 'CC') {
      payOption.pm = 'XICARD';
    }
    const pm = isCNPay ? 'CN' : payOption.pm;
    const req = {
      sellerCode: invoice.sellerCode,
      buyerCode: invoice.buyerCode,
      docIds: payData.invoiceData.docIds,
      payAmt: payData.payModel.amtToPay + (payData.totalWithholdTaxAmount || 0) + (payData.cashDiscountData.totalCashDiscount || 0),
      bankAmt: payData.bankAmt,
      cashDiscount: cashDiscounts,
      cnsSelected: payData.selectedCreditNotesList.map(item => {
        return {
          cnId: item.docId,
          cnAmt: item.docAmt,
          docRef: item.docRef,
          cnRef: item.docRef,
          cnNo: item.docNo
        };
      }),
      deductions: multipayDeductionData,
      paymentMode: payOption,
      pm: pm,
      payDate: this.dateUtils.getTimeStampFromMomentForPayments(payData.payModel.payDate),
      tpin: payData.payModel.payexPin,
      remarks: payData.payModel.remarks || ""
    };
    this.currentPayData.reqData = req;
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAYMENT')).pipe(map(data => {
      const isIncorrectXnPin = data && data.msg && data.msg.indexOf('Incorrect transaction PIN') !== -1;
      const keepUserOnPayPage = isIncorrectXnPin;
      let retUrl = (data.data || {}).redirectUrl;
      const res = Object.assign({}, { isIncorrectXnPin, keepUserOnPayPage, retUrl, payMode: pm }, data);
      this.currentPayData.resData = res;
      console.log("this is result");
      console.log(res);
      return res;
    }));
  }

  rejectInvoice(payData, invoice) {
    //
    const isOtherReason = 'Any other reason'
    const rejectSubReason = (payData.payModel.rejectSubReason === isOtherReason) ? payData.payModel.rejectSubotherReason : (payData.payModel.rejectSubReason || '');
    const req = {
      sellerCode: invoice.sellerCode,
      buyerCode: invoice.buyerCode,
      docIds: payData.invoiceData.docIds,
      tpin: payData.payModel.payexPin,
      remarks: payData.payModel.remarks || "",
      rejectReason: payData.payModel.rejectReason.reason,
      subReason: rejectSubReason,
      chequeDetails: payData.chequeDetails
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('REJECT')).pipe(map(data => {
      const isIncorrectXnPin = data && data.msg && data.msg.indexOf('Incorrect transaction PIN') !== -1;
      const keepUserOnPayPage = isIncorrectXnPin;
      const res = Object.assign({}, { isIncorrectXnPin, keepUserOnPayPage }, data);
      return res;
    }));
  }

  uploadRejectionFiles(file,invoice){
    console.log('file :',file);

    const formData: FormData = new FormData();
    // formData.append('ledgerId', payData.invoice.docId);
    // formData.append('sellerCode', payData.invoice.sellerCode);
    // formData.append('docType', payData.payModel.rejectReason.reason);
    formData.append('file', file);
    var url = this.commonService.getInterfaceUrl('REJECT_UPLOAD')
    var newUrl = `${url}?ledgerId=${invoice.docId}&sellerCode=${invoice.sellerCode}&docType=rejectionReason`
    //formData.append('ppi', ppiVal);
    return this.utilityService.httpMultiPart(newUrl, formData).pipe(map(data => {
          return data;
    }))
  }

  uploadCourierReceipt(courierData, ppiVal) {
    const formData: FormData = new FormData();
    formData.append('file', courierData.courierReceipt);
    formData.append('ppi', ppiVal);
    return this.utilityService.httpMultiPart(this.appConfigService.urls.uploadCourierReceipt, formData).pipe(map(data => {
      return data;
    })).subscribe(data => {
      console.log('Upload Successful');
    });
  }

  /*upload(file: File): Observable<HttpEvent<any>> {
      const formData: FormData = new FormData();

      formData.append('file', file);

      const req = new HttpRequest('POST', ${this.baseUrl}/upload, formData, {
        reportProgress: true,
        responseType: 'json'
      });

      return this.http.request(req);
    }*/

  getCurrentPayData() {
    return this.currentPayData;
  }

  clearCurrentPayData() {
    this.currentPayData = {
      reqData: {},
      resData: {}
    };
  }

  clearStorageInvoices() {
    this.storageService.remove([StringConstants.INVOICE_invoiceToPayStr, StringConstants.INVOICE_multipayStr, StringConstants.INVOICE_multipayGroupStr_TO_PAY_SELECTED]);
    this.storageService.remove(['paymentInitiated']);
    this.selectedInvoices = {};
  }

  initSCFForm() {
    const scfOptions = {
      initSCFAmounts: (obj, scfFields, dontResetPartialForm) => {
        obj['DA'] = 0;
        scfFields.forEach(key => {
          obj[key] = dontResetPartialForm ? obj[key] : 0;
        });
      },
      getTotalAmt: (obj, scfFields) => {
        obj['DA'] = 0;
        let total = 0;
        scfFields.forEach((key) => {
          if (!(isNaN(parseFloat(obj[key])))) {
            total += parseFloat(obj[key]);
          }
        });
        obj['DA'] = total;
        return total;
      }
    };
    return scfOptions;
  }

  // TODO, ideally controller should not be aware of action param
  getBalance(payData, invoice, options: any = {}) {
    const userProfile = this.authenticationService.currentUserValue;
    const req = {
      RC: userProfile.userCode,
      DC: invoice.DC,
      CC: invoice.CC,
      BO: payData.payModel.bank.BO,
      TI: payData.invoiceData.TI,
      action: options.isIBP ? Config.webActions.NEFT_BAL : Config.webActions.GET_ELOAN_LIMIT
    };
    return this.utilityService.httpPost(req, this.appConfigService.urls.invoiceUrl).pipe(map(data => {
      const serviceData = data || {};
      const balance = ((serviceData.data || {}).BAL) || 0;
      const balanaceAfterPay = balance - payData.invoiceData.BA;
      let validationMessage = serviceData.cfBankAgingLimit;
      let paymentAllowed = true;
      if (typeof validationMessage !== 'undefined') {
        paymentAllowed = data.cfBankAgingLimit;
      } else {
        paymentAllowed = balanaceAfterPay > 0;
      }
      payData.payModel.bank.balance = balance;
      return {
        success: balanaceAfterPay > 0,
        balanaceAfterPay: balanaceAfterPay,
        paymentAllowed: paymentAllowed,
        validationMsg: data.cfBankAgingLimitMsg,
        balance: balance,
        isIBP: options.isIBP,
        isEloan: options.isEloan
      };
    }));
  }

  updatePaymentStatusForPaygateway(data) {
    const userProfile = this.authenticationService.currentUserValue;
    const req = Object.assign({}, {
      RC: userProfile.userCode,
      action: Config.webActions.UPDATE_PAYMENT_STATUS
    }, data);
    return this.utilityService.httpPost(req, this.appConfigService.urls.base).pipe(map(data => {
      return data;
    })).subscribe(data => {
    });
  }

  getVIDsForInvoice(payData) {
    if (payData.invoiceData.vidsData) {
      return this.dataService.getDummyObservable(payData.invoiceData.vidsData);
    }
    const userProfile = this.authenticationService.currentUserValue;
    const req = {
      RC: userProfile.userCode,
      IN: payData.invoiceData.invoice.IN,
      action: Config.webActions.GET_VIDS_FOR_SCF
    };
    return this.utilityService.httpPost(req, this.appConfigService.urls.invoiceUrl).pipe(map(data => {
      const vidsData = data.data.lineItem.map((lineItem: any) => {
        const bDate = this.dateUtils.getFormattedDateForDisplay(moment(lineItem.BDATE));
        return {
          id: lineItem.ID || this.dataService.getRandomNo(100000),
          vid: lineItem.VID,
          bDate: bDate,
          bNo: lineItem.BNO,
          des: lineItem.DES,
          amt: lineItem.NAMT,
          ptn: lineItem.PTN,
          searchKey: `${lineItem.VID}_${lineItem.DES}_${lineItem.PTN}`
        }
      });
      payData.invoiceData.vidsData = vidsData;
      return vidsData;
    }));
  }

  setMultipayGroupStorageData(selectedMultipayGroup) {
    return this.storageService.add(StringConstants.INVOICE_multipayGroupStr_TO_PAY_SELECTED, selectedMultipayGroup);
  }

  setPaymentModeToMultipayGroup(payData, selectedMultipayGroup) {
    payData.selectedMultipayGroup = selectedMultipayGroup;
  }

  validateDeduction(payData, invoice, deductionModel) {
    let isDeductionValid = false;
    deductionModel.invalidMsg = '';
    try {
      if (deductionModel.reason && deductionModel.reason.reason && deductionModel.amt) {
        const invDeductionAmt = parseFloat(deductionModel.amt);
        if (invDeductionAmt <= 0) {
          return false;
        }
        const totalInvDeduction = invoice.deductions.reduce((total, deduction) => {
          return total + parseFloat(deduction.amt);
        }, 0);
        const totalWHTInvDeduction = invoice.whtDeductions.reduce((total, deduction) => {
          return total + parseFloat(deduction.amt);
        }, 0);
        if (invoice.dueAmt > (invDeductionAmt + totalInvDeduction + totalWHTInvDeduction)) {
          isDeductionValid = true;
        } else {
          // deductionModel.invalidMsg = `${this.deductionAmountInvalid} ${invoice.finalPayAmtFormatted}.`
          deductionModel.invalidMsg = `${this.deductionAmountInvalid}`
        }
      }
    } catch (err) {
    }
    return isDeductionValid;
  }

  private clearWHTDeductions(invoice) {
    invoice.whtDeductionModel = {
      reason: '',
      amt: '',
      isValid: false,
    };
    invoice.whtDeductions.splice(0, invoice.whtDeductions.length);
  }

  addDeductionToInvoice(payData, invoice, deductionModel, deductionsArr, fromAddMandatory = false) {
    this.clearWHTDeductions(invoice);
    const existingDeduction = deductionsArr.find(deduction => deduction.reason === deductionModel.reason.reason);
    if (existingDeduction) {
      existingDeduction.amt += parseFloat(deductionModel.amt);
      // Carry over a document attached on the entry row, if any.
      if (deductionModel.supportingDoc) {
        existingDeduction.supportingDoc = deductionModel.supportingDoc;
        existingDeduction.supportingDocName = deductionModel.supportingDocName;
      }
    } else {
      deductionsArr.push({
        reason: deductionModel.reason.reason,
        id: deductionModel.reason.id,
        WHT: deductionModel.reason.WHT,
        amt: parseFloat(deductionModel.amt),
        mandatory: deductionModel.mandatory,
        // Supporting document attached on the entry row (client-side only).
        supportingDoc: deductionModel.supportingDoc,
        supportingDocName: deductionModel.supportingDocName
      });
    }
    deductionModel = Object.assign(deductionModel, {
      reason: '',
      amt: '',
      isValid: false,
      invalidMsg: '',
      supportingDoc: undefined,
      supportingDocName: undefined
    });
    this.processDeductions(payData);
    if (!fromAddMandatory) {
      payData.addMandatoryWHTReasons(payData);
    }
  }

  removeDeduction(payData, invoice, deductionIndex, deductionArr) {
    this.clearWHTDeductions(invoice);
    deductionArr.splice(deductionIndex, 1);
    this.processDeductions(payData);
    payData.addMandatoryWHTReasons(payData);
  }

  processDeductions(payData, dontsetPartialAmt = false) {
    let isMultiPartialPay = false;
    let totalDeductionForAllInvoices = 0;
    let totalWithholdTaxAmount = 0;
    let anyNonMandatoryDeductionApplied = false;
    payData.invoiceData.invoices.forEach(inv => {
      const totalDeduction = inv.deductions.reduce((total, deduction) => {
        return total + deduction.amt;
      }, 0);
      const withholdTaxAmount = inv.whtDeductions.reduce((total, deduction) => {
        return total + deduction.amt;
      }, 0);
      if (totalDeduction > 0 || withholdTaxAmount > 0) {
        isMultiPartialPay = true;
      }
      if (totalDeduction > 0 || inv.whtDeductions.filter(whtDeduction => !whtDeduction.mandatory).length > 0) {
        anyNonMandatoryDeductionApplied = true;
      }
      const invCashDiscount = 0;//((payData.invCDAmts || {})[inv.TI]) || 0;
      const finalInvoicePayAmt = inv.dueAmt - (totalDeduction + withholdTaxAmount + invCashDiscount);
      const effectiveInvoiceBalance = inv.dueAmt - totalDeduction;
      inv.totalDeductionAmt = totalDeduction;
      inv.finalPayAmt = finalInvoicePayAmt;
      inv.finalPayAmtFormatted = this.currencyDisplayService.getFormattedCurrencyStr({amt: finalInvoicePayAmt, curr: payData.invoiceData.currCode});
      inv.effectiveInvBalFormatted = this.currencyDisplayService.getFormattedCurrencyStr({amt: effectiveInvoiceBalance, curr: payData.invoiceData.currCode});
      inv.totalDeductionAmtFormatted = this.currencyDisplayService.getFormattedCurrencyStr({amt: inv.totalDeductionAmt, curr: payData.invoiceData.currCode});
      inv.withholdTaxAmount = withholdTaxAmount;
      totalDeductionForAllInvoices += totalDeduction;
      totalWithholdTaxAmount += withholdTaxAmount;
      // inv.discountsRate = payData.cashDiscountData.cdInvoices ? payData.cashDiscountData.cdInvoices.filter( (elem) => elem.docId === inv.docId)[0].discountRate : 0;
      // inv.discountsAmt = payData.cashDiscountData.cdInvoices ? payData.cashDiscountData.cdInvoices.filter( (elem) => elem.docId === inv.docId)[0].discountAmt : 0;
      if(payData.invoice.docType=="INV"){
        if (payData.cashDiscountData.cdInvoices && payData.cashDiscountData.cdInvoices.length > 0) {
          const cdInvoice = payData.cashDiscountData.cdInvoices.filter( (elem) => elem.docId === inv.docId)[0];
          if (cdInvoice) {
            inv.discountsRate = cdInvoice.discountRate;
            inv.discountsAmt = cdInvoice.discountAmt;
          }
        }
      }
    });
    payData.isMultiPartialPay = isMultiPartialPay;
    payData.anyNonMandatoryDeductionApplied = anyNonMandatoryDeductionApplied;
    payData.totalDeductionForAllInvoices = (totalDeductionForAllInvoices + totalWithholdTaxAmount);
    payData.totalWithholdTaxAmount = totalWithholdTaxAmount;
    // Formatted running totals for the modal footer strip.
    const netAmountDue = payData.invoiceData.BA - payData.totalDeductionForAllInvoices;
    payData.totalDeductionForAllInvoicesFormatted = this.currencyDisplayService.getFormattedCurrencyStr({ amt: payData.totalDeductionForAllInvoices, curr: payData.invoiceData.currCode });
    payData.netAmountDueFormatted = this.currencyDisplayService.getFormattedCurrencyStr({ amt: netAmountDue, curr: payData.invoiceData.currCode });
    if (!dontsetPartialAmt) {
      payData.setPartialAmt(payData.invoiceData.dueAmt - payData.totalDeductionForAllInvoices);
    }
  }

  clearDeductions(payData) {
    payData.invoiceData.invoices.forEach(inv => {
      inv.deductions = [];
      inv.whtDeductions = [];
      inv.deductionModel = {
        reason: '',
        amt: '',
        isValid: false,
        invalidMsg: ''
      };
      inv.whtDeductionModel = {
        reason: '',
        amt: '',
        isValid: false,
      };
    });
    this.processDeductions(payData);
    payData.addMandatoryWHTReasons(payData);
  }

  calculateDeductionAmt(payData, invoice, deductionModel) {
    deductionModel.isreadonly = true;
    if (deductionModel.reason) {
      const existingDeduction = invoice.whtDeductions.find(deduction => deduction.reason === deductionModel.reason.reason);
      if (!existingDeduction) {
        if (deductionModel.reason.percentage > -1) {
          const percentage = deductionModel.reason.percentage / 100;
          const orgTaxableAmt = invoice[deductionModel.reason.baseValueField] || invoice.dueAmt;
          const orgTaxablePerc = orgTaxableAmt / invoice.dueAmt;
          if (!invoice.deductions.length) {
            deductionModel.amt = this.dataService.roundNumToTwoDecimalPlace(orgTaxableAmt * percentage);
          } else {
            const invNewPayableAmt = invoice.dueAmt - (invoice.totalDeductionAmt || 0);
            const newTaxableAmt = invNewPayableAmt * orgTaxablePerc;
            deductionModel.amt = this.dataService.roundNumToTwoDecimalPlace(newTaxableAmt * percentage);
          }
        } else if (deductionModel.reason.amt > -1) {
          deductionModel.amt = this.dataService.roundNumToTwoDecimalPlace(deductionModel.reason.amt);
        } else {
          deductionModel.isreadonly = false;
        }
        deductionModel.isValid = this.validateDeduction(payData, invoice, deductionModel);
      } else {
        deductionModel.isValid = false;
      }
    } else {
      deductionModel.isValid = false;
    }
    if (!deductionModel.isValid) {
      deductionModel.amt = undefined;
    }
  }

  getDeductionsWithShortPay(payData, isKnockOff=false) {
    const selectedInvoices = !isKnockOff ? payData.invoiceData.invoices : payData.invoices
    const invoicesDeductionsData = selectedInvoices.map((inv) => {
      const totalDeductionAmt = (inv.totalDeductionAmt || 0) + (inv.withholdTaxAmount || 0);
      const totalUnaccountedBalance = inv.dueAmt - (inv.userPartialPayAmount + totalDeductionAmt);
      const deductions = (inv.deductions || []).concat(inv.whtDeductions || []).map((deduction) => {
        return {
          reason: deduction.reason,
          WHT: deduction.WHT,
          amt: deduction.amt,
          autoAmount: deduction.WHT ? deduction.amtToAutoPopulate : undefined,
          subReason: deduction.subReason,
        };
      });
      const nonWHTDeductionAmt = deductions.filter((deduction) => !deduction.WHT).reduce((total, deduction) => {
        return total + deduction.amt;
      }, 0) || 0;
      if (inv.userPartialPayAmount > 0) {
        deductions.push({
          reason: "USER SHORT PAY",
          WHT: false,
          amt: parseFloat((totalUnaccountedBalance || 0).toFixed(2)),
        });
      }
      return {
        docId: inv.docId,
        deductions,
        amt: totalDeductionAmt + parseFloat((totalUnaccountedBalance || 0).toFixed(2)),
        dueAmt: inv.dueAmt,
        payable: inv.userPartialPayAmount > 0 ? inv.userPartialPayAmount : inv.dueAmt - nonWHTDeductionAmt,
      };
    });
    const totalPayable = invoicesDeductionsData.reduce((total, inv) => total + inv.payable, 0);
    return {
      deductions: invoicesDeductionsData.filter(
        (item) => item.deductions.length > 0
      ),
      totalPayable,
    };
  }

  validatePayment(payData) {
    let paymentValid = true, pinRequiredForPayment = true;
    let paymentOptionValid = true;
    let creditLimitExceedError = '';
    const payModel = payData.payModel || {};
    const isCardPayment = payModel?.bank?.pm.toUpperCase() === 'XICARD';
    if (payModel.bank && payModel.bank.checkBalance) {
      paymentOptionValid = payModel.bank.balance >= payData.bankAmt;
    }
    if (!payModel.bank && (payData.bankAmt > 0)) {
      paymentValid = false;
    }
    if (isCardPayment) {
      const cardCVV = payModel.bank.cardCVV2;
      if (!cardCVV || cardCVV.length < 3 || cardCVV.length > 4) {
        paymentValid = false;
      }
    }
    //Hard coded condition
    if (isCardPayment && payData.bankAmt >= 800) {
      creditLimitExceedError = StringConstants.MESSAGES.CREDIT_LIMIT_EXCEED || StringConstants.MESSAGES.PAYMENT_METHOD_NOT_ALLOWED;
      paymentValid = false;
    }
    if (payModel.bank && payModel.bank.retrievingBalance) {
      paymentValid = false;
    }
    pinRequiredForPayment = !payData.bankAmt || (payModel.bank && payModel.bank.pinRequired);
    const isPinValid = pinRequiredForPayment ? (payModel.payexPin && payModel.payexPin.length >= 4 && payModel.payexPin.length <= 6) : true;
    payData.pinRequiredForPayment = pinRequiredForPayment;
    payData.paymentValid = isPinValid && paymentValid && paymentOptionValid;
    payData.creditLimitExceedError = creditLimitExceedError;
  }

  getSurchargeDataForPayment(payData) {
    const hardCodeSurcharge = false;
    const isCTUser = (this.authenticationService?.currentUserValue?.userId || '').substring(0, 1) !== '1';
    if (isCTUser) {
      return this.dataService.getDummyObservable({});
    }
    if (hardCodeSurcharge) {
      const surchargePerc = 1.8;
      const surchargeData = {
        "surchargeFee": this.dataService.roundNumToTwoDecimalPlace(payData.bankAmt * (surchargePerc / 100)),
        "surchargeFeePercent": surchargePerc,
      };
      return this.dataService.getDummyObservable(surchargeData);
    } else {
      const req = Object.assign({
        buyerCode: payData.invoiceData.invoice.buyerCode,
        sellerCode: payData.invoiceData.invoice.sellerCode,
        amount: this.dataService.roundNumToTwoDecimalPlace(payData.bankAmt),
        card: payData.payModel.bank.card,
      }, { paymentMode: payData.payModel.bank });
      return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('GET_SURCHARGE')).pipe(map(data => {
        return data.data || data || {};
      }));
    }
  }
}
